module.exports = __webpack_public_path__ + "assets/dreamweaver.fc6d9d92.svg";